<template>
    <div style="width: 100%; background-color: var(--primary)">
        <v-app-bar color="primary" dark class="router-view topbar">
            <!-- Ícone de menu lateral -->
            <v-app-bar-nav-icon
                    class="toggle-visibility"
                    @click="toggleDrawer"
                    v-show="exibirMenuIcon"
            >
                <v-icon :class="{ 'rotate180': drawer_open_computed }">
                    {{ drawer_open_computed ? 'chevron_right' : 'mdi-menu' }}
                </v-icon>
            </v-app-bar-nav-icon>

            <!-- Título da barra -->
            <v-toolbar-title>
                <strong v-if="$vuetify.breakpoint.smAndUp">
                    {{ painel ? 'Painel Administrativo:' : 'Plataforma de Vendas:' }}
                </strong>
                {{ painel ? 'Seja bem-vindo,' : 'Bons Negócios,' }} {{ primeiroNome }}!
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <!-- Tooltip com informações do usuário -->
            <v-tooltip bottom color="white">
                <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                        <v-icon class="mr-4" size="28">mdi-account-circle</v-icon>
                    </span>
                </template>
                <div style="color: #222;">
                    <strong class="font-weight-bold">{{ nome }}</strong><br />
                    {{ `Usuário: ` + $session.get('login') }}
                </div>
            </v-tooltip>

            <!-- Botão de logout -->
            <v-tooltip bottom color="white" class="pl-4">
                <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                        <v-btn icon @click="logout">
                            <v-icon size="28">mdi-power-standby</v-icon>
                        </v-btn>
                    </span>
                </template>
                <div style="color: #222;">Sair</div>
            </v-tooltip>
        </v-app-bar>
    </div>
</template>

<script>
  export default {
    name: 'BarraSuperior',
    props: {
      nome: { type: String, required: true },
      value: { type: Boolean },
      painel: { type: Boolean, default: false }
    },
    data () {
      return {
        exibirMenuIcon: true // Controla a exibição do ícone de menu
      }
    },
    computed: {
      drawer_open_computed: {
        get () {
          return this.value
        },
        set (val) {
          this.$emit('input', val)
        }
      },
      primeiroNome () {
        return this.nome.split(' ')[0]
      }
    },
    watch: {
      '$vuetify.breakpoint.xlOnly' (isXlOnly) {
        this.atualizarExibicaoMenuIcon()
      },
      '$vuetify.breakpoint.width' () {
        this.atualizarExibicaoMenuIcon()
      }
    },
    mounted () {
      this.atualizarExibicaoMenuIcon()
    },
    methods: {
      toggleDrawer () {
        this.drawer_open_computed = !this.drawer_open_computed
      },
      logout () {
        this.$emit('logout')
      },
      atualizarExibicaoMenuIcon () {
        // Garante que o ícone de menu seja exibido corretamente
        const larguraTela = this.$vuetify.breakpoint.width
        const xlOnly = this.$vuetify.breakpoint.xlOnly

        // Exibe o ícone de menu se a largura for menor que 1920px ou se não estiver no breakpoint XL
        this.exibirMenuIcon = larguraTela < 1920 || !xlOnly
      }
    }
  }
</script>

<style lang="scss">
.topbar .v-toolbar__content {
  padding: 0;
  height: auto !important;
}
.topbar {
  height: auto !important;
  margin-left: auto;
  margin-right: auto;
  padding: 12px;
  box-shadow: none;
}
.v-tooltip__content.menuable__content__active {
  opacity: 1 !important;
  transition: all ease 0.2s;
}
</style>
